import { useState, useRef, useEffect } from 'react';

import { makeFileName, uploadFile } from './eventFormUtils';
import { useSearchAddress } from '@/hooks/useSearchAddress';
import { useGoogleCalendar, CalendarType } from '@/hooks/useGoogleCalendar';

const useAddEvents = () => {
  const { createCalendarEvent, loading } = useGoogleCalendar();

  const addEvent = async event => {
    try {
      const result = await createCalendarEvent({
        type: CalendarType.GLOBAL, // 기본적으로 GLOBAL 캘린더 사용
        summary: event.summary,
        location: event.location,
        description: event.description,
        start: event.start.dateTime || event.start.date,
        end: event.end.dateTime || event.end.date,
        timeZone: event.start.timeZone,
      });

      if (result) {
        return result;
      } else {
        alert('Error creating event');
        return null;
      }
    } catch (error) {
      alert('Error creating event');
      return null;
    }
  };

  return { addEvent, loading };
};

const useFiles = () => {
  const flyerRef = useRef(null);
  const documentRef = useRef(null);
  const [flyer, setFlyer] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [document, setDocument] = useState(null);
  const uploadFlyer = () => {
    flyerRef.current.value = null;
    flyerRef.current && flyerRef.current.click();
  };

  const handleFlyerChange = event => {
    const selectedFile = event.target.files[0];
    const reader = new FileReader();
    reader.onload = () => {
      if (typeof reader.result === 'string') {
        setPreviewUrl(reader.result);
      }
    };
    reader.readAsDataURL(selectedFile);
    setFlyer(selectedFile);
  };

  const uploadDocument = () => {
    documentRef.current.value = null;
    documentRef.current && documentRef.current.click();
  };

  const handleDocumentChange = event => {
    const selectedFile = event.target.files[0];
    setDocument(selectedFile);
  };

  const handleDeleteFlyer = e => {
    e.stopPropagation();
    setFlyer(null);
    setPreviewUrl(null);
    flyerRef.current.value = null;
  };

  const handleDocumentDelete = e => {
    e.stopPropagation();
    setDocument(null);
  };

  const handleUploadFile = async (key: string) => {
    let data = [];
    if (flyer) {
      const fileName = makeFileName(key, flyer.name);
      const fileKey = 'space-calendar/flyer/' + fileName;
      const fileData = {
        key: fileKey,
        file: flyer,
      };
      data.push(fileData);
    }
    if (document) {
      const fileName = makeFileName(key, document.name);
      const fileKey = 'space-calendar/document/' + fileName;
      const fileData = {
        key: fileKey,
        file: document,
      };
      data.push(fileData);
    }

    const responses = await Promise.all(
      data.map(fileData => uploadFile(fileData.key, fileData.file))
    );

    return responses;
  };

  return {
    flyerRef,
    documentRef,
    flyer,
    previewUrl,
    document,
    uploadFlyer,
    handleFlyerChange,
    uploadDocument,
    handleDocumentChange,
    handleDeleteFlyer,
    handleUploadFile,
    handleDocumentDelete,
  };
};

// useSearchAddress는 이제 별도 파일에서 import합니다

export { useAddEvents, useSearchAddress, useFiles };
